function getFocusableElements(container) {
  if (container) {
    return Array.from(
      container.querySelectorAll(
        "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
      )
    );
  }

}

const onmouseleaveHandeler = (e) => {
  if (e.classList.contains('variant_image_active')) {
    e.classList.remove('variant_image_active');
  }
}

(() => {
  // let flickityList = document.querySelectorAll('[data-flickity]');

  // for (let i = 0, t = flickityList.length; i < t; i++) {
  //     let flkty = Flickity.data(flickityList[i]);
  //     if (flkty) {
  //       let vimeo_iframe = flkty.selectedElement.querySelector('iframe');

  //       if(vimeo_iframe) {
  //         let player = new Vimeo.Player(vimeo_iframe);
  //         player.on('loaded', (e) => {
  //           player.getPaused().then(function(paused) {
  //             if(paused) {
  //               player.play();
  //             }
  //           });
  //         });
  //       } else {
  //         return false;
  //       }
  //     }
  // }
})();

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  if (window.innerWidth > 750) {
    if (summary.closest('header-menu')) {
      summary.closest('details').addEventListener('mouseenter', (event) => {
        const detailsElement = event.currentTarget;
        if (!detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
          detailsElement.setAttribute('open', 'true');
          event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'true');
        }

      });

      summary.closest('details').addEventListener('mouseleave', (event) => {
        const detailsElement = event.currentTarget;
        if (detailsElement.hasAttribute('open') && !detailsElement.classList.contains("menu-drawer-container") && !detailsElement.classList.contains("menu-drawer__menu-item")) {
          detailsElement.removeAttribute('open');
          event.currentTarget.querySelector("summary").setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  summary.addEventListener('click', (event) => {
    if (summary.classList.contains('matat_filters__summary')) {
      const detailsElement = summary.closest("details");
      if (detailsElement && !detailsElement.hasAttribute("open")) {
        document.querySelectorAll(".matat-filter-body details[open]").forEach((openDetail) => {
          openDetail.removeAttribute("open");
        });
      }
      const sliderWrapper = document.getElementById('matat-range-slider');
      if (sliderWrapper.rangeable) {
        sliderWrapper.rangeable.destroy?.(); // Optional chaining
        sliderWrapper.style.display = 'none';
        sliderWrapper.offsetHeight; // force reflow
        sliderWrapper.style.display = '';
        MatatFiltersForm.priceRangeSlider(); // re-init
      }
    }
    if (summary.closest('.product__accordion')) {
      const detailsElement = summary.closest("details");
      if (detailsElement && !detailsElement.hasAttribute("open")) {
        document.querySelectorAll(".product__accordion details[open]").forEach((openDetail) => {
          openDetail.removeAttribute("open");
        });
      }
    }
    if (document.querySelector(".header__search details").hasAttribute("open")) {
      document.querySelector(".header__search details").removeAttribute("open")
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  // document.querySelectorAll('.js-youtube').forEach((video) => {
  //   video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  // });
  // document.querySelectorAll('.js-vimeo').forEach((video) => {
  //   video.contentWindow.postMessage('{"method":"pause"}', '*');
  // });
  // document.querySelectorAll('video').forEach((video) => video.pause());
  // document.querySelectorAll('product-model').forEach((model) => {
  //   if (model.modelViewerUI) model.modelViewerUI.pause();
  // });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  connectedCallback() {
    this.loadContent();
  }

  loadContent(focus = true) {
    // window.pauseAllMedia();
    // if (!this.getAttribute('loaded')) {
    //   const content = document.createElement('div');
    //   content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

    //   this.setAttribute('loaded', true);
    //   const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
    //   if (focus) deferredElement.focus();
    //   if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
    //     // force autoplay for safari
    //     deferredElement.play();
    //   }
    // }
  }
}

customElements.define('deferred-media', DeferredMedia);

document.body.addEventListener('click', function (e) {
  let target = e.target;
  if (target.classList.contains('custom_variation_button')) {
    let parentItem = target.closest('.product-card-wrapper').querySelector('.product-card_inline-variation').querySelector('.product-form__input.listen_color_change');
    let actual_var_item = parentItem.querySelector('[value="' + target.value + '"]');
    actual_var_item.checked = true;
    parentItem.dispatchEvent(new CustomEvent('color_change', { 'detail': target.value }));
    actual_var_item.dispatchEvent(new Event('custom_change'));
    // let variant_radios = target.closest('.product-card-wrapper').querySelector('variant-radios');
    // variant_radios.dispatchEvent(new Event('change'));
  }
  if (target.closest('variant-radios') && target.closest('.product-card-wrapper')) {
    if (target.tagName.toUpperCase() == 'INPUT') {
      target.closest('variant-radios').dispatchEvent(new Event('change'));
    }
  }
});

document.addEventListener("DOMContentLoaded", (event) => {
  if (document.querySelector('.flikity_grid_image')) {
    var carousel = document.querySelectorAll('.flikity_grid_image');
    var flkty;
    carousel.forEach((slide) => {
      flkty = new Flickity(slide, {
        "imagesLoaded": true,
        "rightToLeft": true,
        "cellAlign": "right",
        "pageDots": false,
        "wrapAround": true,
        "draggable": false,
        "responsive": [
          {
            "breakpoint": 750,
            "settings": {
              "freeScroll": true,
              "wrapAround": false,
              "contain": true,
              "prevNextButtons": true,
              "draggable": false,
              "pageDots": false
            }
          }
        ]
      });
    })
  }
  // if(document.querySelector(".product__media-list.Product_main_slider")){
  //     var carousel_main = document.querySelectorAll('.product__media-list.Product_main_slider');
  //     carousel_main.forEach((slide) => {
  //         flkty = new Flickity(slide, {
  //         "imagesLoaded": true,
  //         "rightToLeft":true,
  //         "cellAlign":"right",
  //         "pageDots": true,
  //         "prevNextButtons": true,
  //         "wrapAround": true
  //       });
  //     })
  //   }
});

let mobileSwiper = null;

function initMobileSwiper() {
  const wrapper = document.querySelector('.product__media-wrapper');

  // Only proceed if .product__media-wrapper exists in the DOM
  if (!wrapper) return;

  if (window.innerWidth <= 749 && mobileSwiper === null) {
    var swiper = new Swiper('.product__media-list', {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: false,
      rtl: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  } else if (window.innerWidth > 749 && mobileSwiper !== null) {
    mobileSwiper.destroy(true, true);
    mobileSwiper = null;
  }
}

// Run on load
initMobileSwiper();

// Optional: Run on resize
window.addEventListener('resize', () => {
  initMobileSwiper();
});

// const productWrapper = document.querySelector('.single_main_product_wrapper');

// if (productWrapper && !document.querySelector('variant-radios')) {
//   const mainWrapper = productWrapper.querySelector('.product__media-list .swiper-wrapper');

//   // Reset main wrapper
//   mainWrapper.innerHTML = '';
//   console.warn('No color variant — showing all images');

//   // Clone all product slides into main wrapper
//   document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
//     const clone = slide.cloneNode(true);
//     clone.classList.add('swiper-slide');
//     mainWrapper.appendChild(clone);
//   });

//   const galleryEl = productWrapper.querySelector('.main-product-thumbanila-slider');
//   const isInsideMainSliderSide = galleryEl?.closest('.main_slider_side');

//   let mainSwiper, thumbSwiper;

//   if (isInsideMainSliderSide) {
//     const thumbWrapper = productWrapper.querySelector('.thumbnail_slider_side .swiper-wrapper');
//     if (thumbWrapper) {
//       thumbWrapper.innerHTML = '';

//       // Clone all thumbs
//       document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
//         const clone = slide.cloneNode(true);
//         clone.classList.add('swiper-slide');
//         thumbWrapper.appendChild(clone);
//       });
//     }

//     // Init thumb swiper
//     thumbSwiper = new Swiper('.thumbnail_slider_side', {
//       spaceBetween: 15,
//       slidesPerView: 4,
//       watchSlidesProgress: true,
//       rtl: true,
//     });

//     // Init main swiper
//     mainSwiper = new Swiper('.product-slider-gallery', {
//       spaceBetween: 0,
//       rtl: true,
//       thumbs: {
//         swiper: thumbSwiper,
//       },
//     });

//     // Reset to first slide
//     mainSwiper.slideTo(0);
//     thumbSwiper.slideTo(0);
//   } else {
//     // If no side slider, just init main swiper normally
//     mainSwiper = new Swiper('.product-slider-gallery', {
//       spaceBetween: 0,
//       rtl: true,
//     });
//   }

//   // Store swipers globally if you want to reuse
//   window.mainSwiper = mainSwiper;
//   window.thumbSwiper = thumbSwiper;
// }

class VariantSelects extends HTMLElement {

  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

    if (this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
      if (this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')) {
        this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
          const variant_image = this.updateSingleMedia(e.detail);
          if (e.target.closest(".card__inner").querySelector(".card__media").classList.contains("enable_image_slider")) {
            if (variant_image) {
              //  var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}"]`).closest('.pro-media').dataset.index;
              var taeget_index = e.target.closest(".card__inner").querySelector(".card__media").querySelector(`img[src="${variant_image}&width=460"]`).closest('.pro-media').dataset.index;
              //  let taeget_index =
              //   e.target
              //     .closest(".card__inner")
              //     ?.querySelector(".card__media")
              //     ?.querySelector(`img[src="${variant_image}"]`)
              //     ?.closest(".pro-media")

              //     ?.dataset.index || 0;

              var flkty = Flickity.data(e.target.closest(".card__inner").querySelector(".card__media .flickity_grid"));
              if (flkty) {
                flkty.select(taeget_index)
              }
            }
          } else {
            if (variant_image) {
              this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
              this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
            }
            this.closest('.product-card-wrapper').classList.add('variant_image_active');
          }


          // Updating Variant Button
          const variant_details = this.getVariantDetails(e.detail);

          const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
          var $this = this;
          $variant_input.forEach(function (input) {
            var this_value = input.getAttribute('value');
            switch (input.getAttribute('data-option')) {
              case "1":
                var condition = variant_details.find((x) => {
                  return x.available && x.option1 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "2":
                var condition = variant_details.find((x) => {
                  return x.available && x.option2 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              case "3":
                var condition = variant_details.find((x) => {
                  return x.available && x.option3 == this_value
                });
                $this.updateVariantButton(condition, input)
                break;
              default:
            }
          });
        });
      }
    }
    if (this.querySelector(".custom-select")) {
      this.querySelectorAll(".custom-select .custom-selected").forEach((select_opt) => {
        select_opt.addEventListener("click", (e) => {
          e.target.nextElementSibling.classList.toggle("active");
        })
      })
      this.querySelectorAll(".custom-select .custom-select-options div").forEach((opt) => {
        opt.addEventListener("click", (optval) => {
          this.querySelectorAll(".custom-select .custom-select-options div").forEach((optremove) => {
            optremove.classList.remove("selected_val");
          });
          let $optvalue = optval.target.innerHTML;
          optval.target.closest(".custom-select").querySelector(".custom-selected span").innerHTML = $optvalue;
          optval.target.closest(".custom-select-options").classList.remove("active");
          optval.target.classList.add("selected_val");
          // change real select option
          let $s = optval.target.closest(".product-form__input--dropdown").getElementsByTagName("select")[0];
          let $sl = $s.length;
          for (let i = 0; i < $sl; i++) {
            if ($s.options[i].innerHTML == $optvalue) {
              $s.options[i].selected = true;
              // this.fireEvent($s,"change")
              $s.dispatchEvent(new Event("change", { bubbles: true }));
              break;
            }
          }
        })
      })
    }
    this.mainSwiper = null;

    // Wait until DOM + variant is ready
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(() => {
        const selectedColorInput = document.querySelector('.variation-color-wrapper .color_label input:checked');

        if (selectedColorInput) {
          const selectedColor = selectedColorInput.value.trim();

          // Use real variant object (with featured_media) instead of a fake {option1} stub.
          // This ensures slideToSelectedVariant() can find the admin-assigned image.
          const realVariant = this.getVariantData().find(v => v.option1 === selectedColor && v.available)
            || this.getVariantData().find(v => v.option1 === selectedColor);
          this.currentVariant = realVariant || { option1: selectedColor };

          // Call method with color
          this.slideToSelectedVariant(selectedColor);
        } else {
          this.renderAllProductSlider();
          console.warn('No default color variant selected');
          // const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
          // mainWrapper.innerHTML = '';
          // // If 'color' option doesn't exist OR no color selected, just init both swipers normally
          // console.warn('No color variant — showing all images');

          // document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
          //   const clone = slide.cloneNode(true);
          //   clone.classList.add('swiper-slide');
          //   mainWrapper.appendChild(clone);
          // });

          // if (isInsideMainSliderSide) {
          //   const thumbWrapper = document.querySelector('.thumbnail_slider_side .swiper-wrapper');
          //   thumbWrapper.innerHTML = '';


          //   // If no matching thumbs, show all
          //     document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
          //       const clone = slide.cloneNode(true);
          //       clone.classList.add('swiper-slide');
          //       thumbWrapper.appendChild(clone);
          //     });


          //   // Go to first slide
          //   this.mainSwiper.slideTo(0);
          //   this.thumbSwiper.slideTo(0);
          // }

          // // You can call your original init swiper function here
          // if (this.mainSwiper) this.mainSwiper.destroy(true, true);
          // if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);
        }
      }, 100); // wait for Shopify to hydrate
    });
  }

  updateVariantButton(condition, input) {
    if (condition) {
      input.classList.remove('disabled')
    } else {
      input.classList.add('disabled')
    }
  }

  onVariantChange(e) {
    const fieldset = e.target.querySelectorAll('fieldset');
    let checked_count = 0;
    fieldset.forEach((item) => {
      if (item.querySelectorAll('input[type="radio"]:checked').length > 0) {
        checked_count++;
      }
    })
    if (checked_count < fieldset.length) return;
    const product_card = this.closest('.product-card_inline-variation');
    if (product_card) {
      console.log('product_card', product_card);
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updateVariantStatuses();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateVariantInput();
        this.renderProductInfo();
      }
      this.quickAddToCart();
    } else {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantStatuses();


      if (e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
        // this.updateMedia(e.target.value);
        this.slideToSelectedVariant(e.target.value);

      }

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
      }
    }
  }

  quickAddToCart() {
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    let enabledCounter = 0;
    const variant_form = this.querySelector('product-form').querySelector('form');

    inputWrappers.forEach((option, index) => {
      const selectedOptionInput = option.querySelector(':checked');
      if (selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
        enabledCounter++;
        if (enabledCounter == inputWrappers.length) {
          variant_form.dispatchEvent(new Event('submit'))
          this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
          this.closest('.product-card-wrapper').classList.add('adding_cart')
        }
      }
      // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      // this.setInputAvailability(optionInputs, availableOptionInputsValue)

      // if(product_card && option.classList.contains('visually-hidden')) {
      //   product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
      //   const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
      //   this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
      // }
    });
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    console.log('Upate');
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia(color) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    // const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    // mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // if (!modalContent) return;
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);

    // this.getVariantData().find((variant) => {
    //   return !variant.options.map((option, index) => {
    //     return this.options[index] === option;
    //   }).includes(false);
    // });

    var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function (obj) { return obj.featured_media.preview_image.src; }))];
    let main_images = [],
      thumb_images = [];

    for (let img_src of variant_images) {
      const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
      let main_img = document.createElement("li");
      main_img.classList.add(...main_classes);
      main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                    <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                    <div class="product__media media media--transparent has_zoom_element">
                          <img src="${img_src}&amp;width=1946" alt="">
                        </div>
                    </div>
                  </a>`;
      main_images.push(main_img);

      const thumb_classes = ['thumbnail-list__item', 'slider__slide']
      let thumb_img = document.createElement("li");
      thumb_img.classList.add(...thumb_classes);
      thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt=""></button>`;
      thumb_images.push(thumb_img);
    }

    const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
    const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
    if (main_old_cells.length) {
      main_product_gallery.remove(main_old_cells);
    }
    main_product_gallery.insert(main_images, 0);
    main_product_gallery.select(0);

    const thumb_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side[data-flickity]'));
    const thumb_old_cells = thumb_gallery.cells.map(cell => cell.element);
    if (thumb_old_cells.length) {
      thumb_gallery.remove(thumb_old_cells);
    }
    setTimeout(() => {
      if (thumb_images.length > 4) {
        thumb_gallery.insert(thumb_images, 0);
      } else {
        let flktyOptions = JSON.parse(thumb_gallery.element.dataset.flickity);
        delete flktyOptions.wrapAround;
        flktyOptions.contain = true;
        thumb_gallery.insert(thumb_images, 0);

        setTimeout(() => {
          thumb_gallery.destroy();
          let new_flickity = new Flickity(thumb_gallery.element, flktyOptions);
          new_flickity.reposition();
        }, 50);
      }
    }, 20);
  }

  // slideToSelectedVariant(color){
  //   console.log("working")
  //   if (!this.currentVariant) return;
  //   if (!this.currentVariant.featured_media) return;
  //   var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
  //   var target_image = variant_images[0];
  //   var taeget_index = document.querySelector(`.slider__slide a[href="${target_image}"]`).closest('.product__media-item').dataset.index;
  //   var flkty = Flickity.data(document.querySelector('.product-slider-gallery[data-flickity]'));
  //   if(flkty){
  //     flkty.select(taeget_index)  
  //   }
  //   return;
  // }

  // New version 
  renderAllProductSlider() {
    // if (!this.currentVariant || !this.currentVariant.option1) return;
    // alert('Here');

    // const variantColor = this.currentVariant.option1.toLowerCase();

    // Destroy previous Swipers
    // if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    // if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);


    // // Clear current Swiper wrappers
    // const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
    // if(mainWrapper == null){
    //   return;
    // }
    // console.log(mainWrapper)
    // mainWrapper.innerHTML = '';

    // let mainMatchFound = false;


    // // If no match found, show all main slides
    // if (!mainMatchFound) {
    //   document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
    //     const clone = slide.cloneNode(true);
    //     clone.classList.add('swiper-slide');
    //     mainWrapper.appendChild(clone);
    //   });
    // }

    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);

    const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
    if (!mainWrapper) return; // <-- guard

    mainWrapper.innerHTML = '';

    document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
      const clone = slide.cloneNode(true);
      clone.classList.add('swiper-slide');
      mainWrapper.appendChild(clone);
    });

    const galleryEl = document.querySelector('.main-product-thumbanila-slider');
    const isInsideMainSliderSide = galleryEl?.closest('.main_slider_side');

    if (isInsideMainSliderSide) {
      const thumbWrapper = document.querySelector('.thumbnail_slider_side .swiper-wrapper');
      thumbWrapper.innerHTML = '';

      let thumbMatchFound = false;

      document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
        const alt = slide.getAttribute('data-media-alt')?.toLowerCase() || '';

        if (alt === variantColor) {
          thumbMatchFound = true;
          const clone = slide.cloneNode(true);
          clone.classList.add('swiper-slide');
          thumbWrapper.appendChild(clone);
        }
      });

      // If no matching thumbs, show all
      if (!thumbMatchFound) {
        document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('swiper-slide');
          thumbWrapper.appendChild(clone);
        });
      }

      // Re-initialize Swipers
      this.thumbSwiper = new Swiper('.thumbnail_slider_side', {
        spaceBetween: 15,
        slidesPerView: 4,
        watchSlidesProgress: true,
        rtl: true,
      });

      this.mainSwiper = new Swiper('.product-slider-gallery', {
        spaceBetween: 0,
        rtl: true,
        thumbs: {
          swiper: this.thumbSwiper,
        },
      });

      // Go to first slide
      this.mainSwiper.slideTo(0);
      this.thumbSwiper.slideTo(0);
    }

    if (window.innerWidth <= 749) {
      initMobileSwiper();
    }
    if (mobileSwiper !== null) {
      mobileSwiper.destroy(true, true);
      mobileSwiper = null;
    }
    if (window.innerWidth <= 749) {
      var swiper = new Swiper('.product__media-list', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        rtl: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }

  slideToSelectedVariant(color) {
    // Use the directly-passed color param as primary source.
    // Fall back to currentVariant.option1 only if color param is missing.
    const variantColor = (color || (this.currentVariant && this.currentVariant.option1) || '').toLowerCase();
    if (!variantColor) return;

    // ─── FIX 1: Smart alt detection via variant.featured_media.id ─────────────
    // Problem: product page was matching image slides by (data-media-alt === variantColor)
    // which fails when the image alt text differs from the variant option name.
    // Fix: get featured_media.id from variant JSON → find the slide with that media id
    // → read its ACTUAL alt text → use that to match ALL related slides for this color.
    const variantDataForColor = this.getVariantData().filter(v =>
      v.option1 && v.option1.toLowerCase() === variantColor
    );
    const featuredMediaIds = variantDataForColor
      .filter(v => v.featured_media)
      .map(v => String(v.featured_media.id));

    let detectedAlt = variantColor; // fallback: match by variant name
    if (featuredMediaIds.length > 0) {
      const allSlides = Array.from(document.querySelectorAll('#all-product-slides .product__media-item'));
      const featuredSlide = allSlides.find(slide => {
        // data-media-id = "<section.id>-<media.id>"; media.id is always trailing digits
        const mediaIdNum = (slide.getAttribute('data-media-id') || '').match(/(\d+)$/)?.pop() || '';
        return featuredMediaIds.includes(mediaIdNum);
      });
      if (featuredSlide) {
        const foundAlt = featuredSlide.getAttribute('data-media-alt')?.toLowerCase() || '';
        if (foundAlt) detectedAlt = foundAlt;
      }
    }
    // ──────────────────────────────────────────────────────────────────────────

    // ─── FIX 2: Admin-assigned image index ────────────────────────────────────
    // Track while cloning slides which index corresponds to currentVariant.featured_media
    // so we can jump to it instead of always showing slide 0.
    const currentFeaturedMediaId = this.currentVariant?.featured_media?.id
      ? String(this.currentVariant.featured_media.id)
      : null;
    let targetSlideIndex = 0;
    // ──────────────────────────────────────────────────────────────────────────

    // Destroy previous Swipers
    if (this.mainSwiper) this.mainSwiper.destroy(true, true);
    if (this.thumbSwiper) this.thumbSwiper.destroy(true, true);

    // Guard: if no swiper wrapper exists, nothing to do
    const mainWrapper = document.querySelector('.product__media-list .swiper-wrapper');
    if (!mainWrapper) return;

    mainWrapper.innerHTML = '';
    let mainMatchFound = false;
    let cloneIndex = 0;

    document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
      const alt = slide.getAttribute('data-media-alt')?.toLowerCase() || '';
      const mediaIdNum = (slide.getAttribute('data-media-id') || '').match(/(\d+)$/)?.pop() || '';
      // Match by detected alt OR directly by featured_media id
      if (alt === detectedAlt || featuredMediaIds.includes(mediaIdNum)) {
        mainMatchFound = true;
        // Track the index of the admin-assigned image
        if (currentFeaturedMediaId && mediaIdNum === currentFeaturedMediaId) {
          targetSlideIndex = cloneIndex;
        }
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        mainWrapper.appendChild(clone);
        cloneIndex++;
      }
    });

    if (!mainMatchFound) {
      document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        mainWrapper.appendChild(clone);
      });
      targetSlideIndex = 0; // fallback: start from first
    }

    const galleryEl = document.querySelector('.main-product-thumbanila-slider');
    const isInsideMainSliderSide = galleryEl?.closest('.main_slider_side');

    if (isInsideMainSliderSide) {
      const thumbWrapper = document.querySelector('.thumbnail_slider_side .swiper-wrapper');
      if (thumbWrapper) {
        thumbWrapper.innerHTML = '';
        let thumbMatchFound = false;

        document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
          const alt = slide.getAttribute('data-media-alt')?.toLowerCase() || '';
          // Thumbnails have no data-media-id; match by detectedAlt
          if (alt === detectedAlt) {
            thumbMatchFound = true;
            const clone = slide.cloneNode(true);
            clone.classList.add('swiper-slide');
            thumbWrapper.appendChild(clone);
          }
        });

        if (!thumbMatchFound) {
          document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
            const clone = slide.cloneNode(true);
            clone.classList.add('swiper-slide');
            thumbWrapper.appendChild(clone);
          });
        }

        this.thumbSwiper = new Swiper('.thumbnail_slider_side', {
          spaceBetween: 15,
          slidesPerView: 4,
          watchSlidesProgress: true,
          rtl: true,
        });

        this.mainSwiper = new Swiper('.product-slider-gallery', {
          spaceBetween: 0,
          rtl: true,
          thumbs: { swiper: this.thumbSwiper },
        });

        // Jump to admin-assigned image instead of always 0
        this.mainSwiper.slideTo(targetSlideIndex);
        this.thumbSwiper.slideTo(targetSlideIndex);
      }
    }

    // Mobile swiper
    if (mobileSwiper !== null) {
      mobileSwiper.destroy(true, true);
      mobileSwiper = null;
    }
    if (window.innerWidth <= 749) {
      mobileSwiper = new Swiper('.product__media-list', {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        rtl: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      });
    }
  }

  updateSingleMedia(color) {
    const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
    const variant_img_src = single_variant_data.featured_image ? single_variant_data.featured_image.src : false;

    return variant_img_src;
  }

  getVariantDetails(color) {
    return this.getVariantData().filter(data => data.title.includes(color));
  }

  updateURL() {
    const product_card = this.closest('.product-card_inline-variation');
    if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const product_card = this.closest('.product-card_inline-variation');
    if (product_card) {
      const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      // input.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="id"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      let $current_var_price = (this.currentVariant.price / 100).toFixed(2);
      console.log($current_var_price);
      let $current_var_price_money = `₪ ${$current_var_price}`;
      document.querySelectorAll(".product__info-wrapper .change-price").forEach((e) => {
        e.innerHTML = $current_var_price_money;
        e.classList.add("price-updated");
      });
    }
  }

  updateVariantStatuses() {
    const product_card = this.closest('.product-card_inline-variation');
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      if (inputWrappers[index - 1].querySelector(':checked')) {
        const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${index}`] === previousOptionSelected).map(variantOption => variantOption[`option${index + 1}`]);
        this.setInputAvailability(optionInputs, availableOptionInputsValue)
        if (product_card && option.classList.contains('visually-hidden')) {
          product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
          const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
          console.log("optionInputsVariant", optionInputsVariant, "availableOptionInputsValue", availableOptionInputsValue)
          this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        }
      }
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (document.querySelector(".backinstock-input-main") && this.currentVariant) {
      document.querySelector(".backinstock-input-main button.matat-stock-notify-submit").setAttribute("data-variant-title", this.currentVariant.title)
    }
    if (!pickUpAvailability) return;
    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
      console.log('Here');
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    const product_card = this.closest('.product-card_inline-variation');

    if (!section || product_card) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const product_card = this.closest('.product-card_inline-variation');

    if (product_card) {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
          const html = raw_html.querySelector('.single_main_product_wrapper');

          // const destination = document.getElementById(`price-${this.dataset.section}`);
          // const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          // const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          // if (source && destination) destination.innerHTML = source.innerHTML;
          // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          // if (skuSource && skuDestination) {
          //   skuDestination.innerHTML = skuSource.innerHTML;
          //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          // }

          // const price = document.getElementById(`price-${this.dataset.section}`);

          // if (price) price.classList.remove('visibility-hidden');

          // if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant
            }
          });
        });
    } else {
      fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {

          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');

          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

          //Sale Detected
          if (html.getElementById(`product-form-${this.dataset.section}`)) {
            if (html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`)) {
              const isSale = html.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector(`.is-sale`);
              if (isSale) {
                document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "inline-block";
              } else {
                document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.sale').style.display = "none";
              }
            }
          }
          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId,
              html,
              variant: this.currentVariant
            }
          });
        });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
      if (modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')) {
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
        if (document.querySelector(".backinstock_feature_enable")) {
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
          addButton.classList.add("hidden");
          addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
          addButton.closest("product-form").classList.add("backinstock-active");
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      if (modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')) {
        document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
        if (document.querySelector(".backinstock_feature_enable")) {
          addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
          addButton.classList.remove("hidden");
          addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
          addButton.closest("product-form").classList.remove("backinstock-active");
        }
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

const productWrapper = document.querySelector('.single_main_product_wrapper');

if (productWrapper && !document.querySelector('variant-radios')) {
  const mainWrapper = productWrapper.querySelector('.product__media-list .swiper-wrapper');

  // Reset main wrapper
  mainWrapper.innerHTML = '';
  console.warn('No color variant — showing all images');

  // Clone all product slides into main wrapper
  document.querySelectorAll('#all-product-slides .product__media-item').forEach(slide => {
    const clone = slide.cloneNode(true);
    clone.classList.add('swiper-slide');
    mainWrapper.appendChild(clone);
  });

  const galleryEl = productWrapper.querySelector('.main-product-thumbanila-slider');
  const isInsideMainSliderSide = galleryEl?.closest('.main_slider_side');

  // 🔹 Destroy old instances before re-init
  if (window.mainSwiper_color) {
    window.mainSwiper_color.destroy(true, true);
    window.mainSwiper_color = null;
  }
  if (window.thumbSwiper_color) {
    window.thumbSwiper_color.destroy(true, true);
    window.thumbSwiper_color = null;
  }

  var mainSwiper_color, thumbSwiper_color;

  if (isInsideMainSliderSide) {
    const thumbWrapper = productWrapper.querySelector('.thumbnail_slider_side .swiper-wrapper');
    if (thumbWrapper) {
      thumbWrapper.innerHTML = '';

      // Clone all thumbs
      document.querySelectorAll('#all-product-slides .thumbnail-list__item').forEach(slide => {
        const clone = slide.cloneNode(true);
        clone.classList.add('swiper-slide');
        thumbWrapper.appendChild(clone);
      });
    }

    // Init thumb swiper
    thumbSwiper_color = new Swiper('.thumbnail_slider_side', {
      spaceBetween: 15,
      slidesPerView: 4,
      watchSlidesProgress: true,
      rtl: true,
    });

    // Init main swiper (✅ reinit pagination properly)
    mainSwiper_color = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true,
      thumbs: {
        swiper: thumbSwiper_color,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    // Reset to first slide
    mainSwiper_color.slideTo(0);
    thumbSwiper_color.slideTo(0);
  } else {
    // If no side slider, just init main swiper normally
    mainSwiper_color = new Swiper('.product-slider-gallery', {
      spaceBetween: 0,
      rtl: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });
  }

  // Store swipers globally
  window.mainSwiper_color = mainSwiper_color;
  window.thumbSwiper_color = thumbSwiper_color;
}


class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      var xx = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
      if (xx) {
        if (xx.closest("fieldset") && xx.closest("fieldset").querySelector("legend span")) {
          xx.closest("fieldset").querySelector("legend span").innerHTML = xx.value;
        }
        return xx.value;
      } else {
        // Return '' instead of undefined so updateMasterId() doesn't fail
        return '';
      }
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
            var elem = document.querySelector('#recomendation');
            var flkty = new Flickity(elem, {
              "rightToLeft": true,
              "cellAlign": "right",
              "pageDots": false,
              "wrapAround": true,
              "contain": true,
              "responsive": [
                {
                  "breakpoint": 750,
                  "settings": {
                    "wrapAround": true,
                    "contain": true,
                    "prevNextButtons": true,
                    "pageDots": false
                  }
                }
              ]
            });
            document.querySelectorAll("#recomendation .enable_image_slider .flickity_grid").forEach((elementItem) => {
              var flkty = new Flickity(elementItem, {
                "imagesLoaded": true,
                "rightToLeft": true,
                "cellAlign": "right",
                "pageDots": false,
                "prevNextButtons": false,
                "wrapAround": true,
                "draggable": false,
                "contain": true,
                "responsive": [
                  {
                    "breakpoint": 750,
                    "settings": {
                      "freeScroll": true,
                      "wrapAround": false,
                      "contain": true,
                      "prevNextButtons": false,
                      "draggable": false,
                      "pageDots": false
                    }
                  }
                ]
              });
            })
            const quickViewButtons = document.querySelectorAll(".mobile-quickview");
            console.log('clicked!');
            if (quickViewButtons.length > 0) {
              quickViewButtons.forEach((button) => {
                button.addEventListener("click", (evt) => {
                  const cardWrapper = evt.target.closest(".card-wrapper");
                  if (!cardWrapper) return;
                  const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
                  quickAddButton?.click();

                  const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='size']");
                  const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");

                  if (mobilePopupElement) {
                    const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
                    if (variationContainer && variantRadios) {
                      mobilePopupElement.classList.add("active");
                      let sizeVariantsHTML = "";
                      cardWrapper.querySelectorAll(".product-card_inline-variation input[name='size']").forEach((input) => {
                        let $disableClass;
                        if (input.classList.contains("disabled")) {
                          $disableClass = "disabled";
                        }
                        sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
                      });
                      variationContainer.innerHTML = sizeVariantsHTML;
                    }
                  }
                });
              });
            }
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// if(window.innerWidth < 750){
//   if(!document.querySelector(".gift-card-single-main-product")){
//     if(document.querySelector(".single_main_product_wrapper")){
//       var flkty = new Flickity( '.product__media-list.contains-media', {
//         "imagesLoaded": true,
//         "rightToLeft":true,
//         "cellAlign":"right",
//         "pageDots": true,
//         "prevNextButtons": true,
//         "wrapAround": true
//     });
//     }
//   }
//   if(document.querySelector(".matat-mobile-zoom-btn")){
//     document.querySelector(".matat-mobile-zoom-btn").addEventListener("click", (e)=>{
//       document.querySelector(".product__media-wrapper .product__media-item.is-selected img").click()
//     })
//   }
// }

if (document.querySelector(".backinstock_feature_enable")) {

  // backin stock feature for product page
  if (document.querySelector(".single-main-product-page")) {
    function validatePhoneNumber() {
      // Get and trim phone number input
      const phoneNumber = document.getElementById('stock-phone').value.trim();

      // Regex pattern for 10-digit phone number
      const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

      // Validate phone number and update message
      const isValid = pattern.test(phoneNumber);
      return isValid;
    }
    document.getElementById('stock-phone').addEventListener("keyup", (e) => {
      let phone_value = e.target.value;
      if (phone_value != "") {
        validatePhoneNumber()
      } else {
        document.getElementById('phoneValidationMsg').textContent = "";
      }
    });
    document.querySelector(".matat-stock-notify-submit").addEventListener("click", () => {
      document.getElementById('phoneValidationMsg').textContent = '';
      let check_phone = validatePhoneNumber();
      if (check_phone) {
        // Get data attributes from the button
        const button = document.querySelector(".matat-stock-notify-submit");
        const data = {
          phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
          dialCode: "972",
          id: button.getAttribute("data-id"),
          product_id: button.getAttribute("data-product_id"),
          action: button.getAttribute("data-action"),
          title: (button.getAttribute("data-title")),
          price_varies: JSON.parse(button.getAttribute("data-price_varies")),
          price: (button.getAttribute("data-price")),
          price_max: (button.getAttribute("data-price_max")),
          price_min: (button.getAttribute("data-price_min")),
          has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
          src: button.getAttribute("data-src"),
          url: button.getAttribute("data-url"),
          user_id: button.getAttribute("data-user_id"),
          email: button.getAttribute("data-email"),
          full_name: button.getAttribute("data-full_name"),
          variant_id: button.getAttribute("data-variant-id"),
          variant_title: button.getAttribute("data-variant-title")
        };

        fetch(`https://x30.co.il/apps/text-me/restock-notifications`, {
          method: 'POST',
          headers: {
            "Content-Type": "application/json",
            "x-shopify-shop-domain": Shopify.shop
          },
          body: JSON.stringify(data)
        })
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }

          })
          .then(data => {
            document.getElementById('phoneValidationMsg').style.color = "green"
            document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        document.getElementById('phoneValidationMsg').textContent = "'מספר טלפון לא תקין.";
      }
    })
    document.querySelector('[name="id"]').addEventListener("change", (e) => {
      let variant_change_val = e.target.value;
      document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id", variant_change_val);
      document.querySelector(".matat-stock-notify-submit").setAttribute("data-id", variant_change_val);
    })
  }
  // collection page back in stack
  class BackinStockmatat extends HTMLElement {
    constructor() {
      super();
      this.addEventListener("click", () => {
        document.querySelector(".matat-product-card-stock").classList.toggle("active");
        document.body.classList.toggle("overflow-hidden");
        let $AllAttributes = this.attributes;
        this.copyAttributes($AllAttributes);
      })
    }

    copyAttributes(att) {
      [...att].forEach((name) => {
        if (name.nodeName != "class") {
          document.querySelector("matat-stock-popup").setAttribute(name.nodeName, name.nodeValue);
        }
      })
    }

  }
  customElements.define('matat-stock', BackinStockmatat);

  // stock popup js starts from here
  class matatStockPopup extends HTMLElement {
    constructor() {
      super();
      this.close = this.querySelector(".close-stock-popup");
      this.button = this.querySelector(".stock-popup-button");
      this.input = this.querySelector("#stock-phone-popup");
      this.close.addEventListener("click", () => {
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      })
      this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
      })
      this.addEventListener("click", (evt) => {
        if (evt.target == this) {
          this.closest(".matat-product-card-stock").classList.remove("active");
          document.body.classList.remove("overflow-hidden");
        }
      })
    }

    validatePhoneNumber(number) {
      // Get and trim phone number input
      const phoneNumber = number.trim();
      // Regex pattern for 10-digit phone number
      const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
      // Validate phone number and update message
      const isValid = pattern.test(phoneNumber);
      return isValid;
    }

    submitStock(ele) {
      document.getElementById('popup_phoneValidation').textContent = '';
      let check_phone = this.validatePhoneNumber(this.input.value);
      if (check_phone) {
        // Get data attributes from the button
        const datas = this;
        const data = {
          phone: this.input.value, // Assuming there's an input for the phone number
          dialCode: "972",
          id: datas.getAttribute("data-id"),
          product_id: datas.getAttribute("data-product_id"),
          action: datas.getAttribute("data-action"),
          title: (datas.getAttribute("data-title")),
          price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
          price: (datas.getAttribute("data-price")),
          price_max: (datas.getAttribute("data-price_max")),
          price_min: (datas.getAttribute("data-price_min")),
          has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
          src: datas.getAttribute("data-src"),
          url: datas.getAttribute("data-url"),
          user_id: datas.getAttribute("data-user_id"),
          email: datas.getAttribute("data-email"),
          full_name: datas.getAttribute("data-full_name"),
          variant_id: datas.getAttribute("data-variant-id"),
          variant_title: datas.getAttribute("data-variant-title")
        };

        fetch('https://x30.co.il/apps/text-me/restock-notifications', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            "x-shopify-shop-domain": Shopify.shop
          },
          body: JSON.stringify(data)
        })
          .then(response => {
            if (!response.ok) {
              document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
              setTimeout(function () {
                document.querySelector(".matat-product-card-stock").classList.remove("active");
                document.body.classList.remove("overflow-hidden");
              }, 500);
              throw new Error('Network response was not ok');
            }

          })
          .then(data => {
            document.getElementById('popup_phoneValidation').classList.add("sucess");
            this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
            document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
            setTimeout(function () {
              document.querySelector(".matat-product-card-stock").classList.remove("active");
              document.body.classList.remove("overflow-hidden");
            }, 200);

          })
          .catch(error => {
            console.error('Error:', error);
          });
      } else {
        document.getElementById('popup_phoneValidation').classList.remove("sucess");
        document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
      }
    }
    displaySuccessMessage(message) {
      this.displayAlertMessage(message, "success");
    }
    displayAlertMessage(message, type = "error") {
      const alertBox = document.createElement("div");
      alertBox.classList.add("alert-box", type);
      alertBox.textContent = message;

      document.body.appendChild(alertBox);

      setTimeout(() => {
        alertBox.remove();
      }, 5000); // Remove after 5 seconds
    }
  }
  customElements.define('matat-stock-popup', matatStockPopup);

}


// login drawer focused css
// const loginPhoneInput = document.querySelector(".matat-login-main #login_phone");
// const otp_codeInput = document.querySelector(".matat-login-main #login_otp");
// const login_page_phoneInput = document.querySelector(".customer.login .matat-login-main #login_phone");
// const login_page_otp_codeInput = document.querySelector(".customer.login .matat-login-main #login_otp");
const toggleFocusClass = (e) => {
  if (e.target.closest(".floating_input_wrap")) {
    e.target.closest(".floating_input_wrap").classList.toggle("focused", e.type === "focus");
  }
  if (e.type == "blur" && e.target.value != "") {
    if (e.target.closest(".floating_input_wrap")) {
      e.target.closest(".floating_input_wrap").classList.add("populated");
    }
  } else {
    if (e.target.closest(".floating_input_wrap")) {
      e.target.closest(".floating_input_wrap").classList.remove("populated");
    }

  }
};
document.querySelectorAll(".form-control").forEach((evt) => {
  evt.addEventListener("focus", toggleFocusClass);
  evt.addEventListener("blur", toggleFocusClass);
})
// loginPhoneInput.addEventListener("focus", toggleFocusClass);
// loginPhoneInput.addEventListener("blur", toggleFocusClass);
// otp_codeInput.addEventListener("focus", toggleFocusClass);
// otp_codeInput.addEventListener("blur", toggleFocusClass);
// if(login_page_phoneInput){
//   login_page_phoneInput.addEventListener("focus", toggleFocusClass);
//   login_page_phoneInput.addEventListener("blur", toggleFocusClass);
// }
// if(login_page_otp_codeInput){
//   login_page_otp_codeInput.addEventListener("focus", toggleFocusClass);
//   login_page_otp_codeInput.addEventListener("blur", toggleFocusClass);
// }
class GoogleLoginBtn extends HTMLElement {
  constructor() {
    super();
    this.querySelector(".google-button").addEventListener('click', () => {
      document.querySelector("#google-login").click();
    })
  }

}
customElements.define('button-google', GoogleLoginBtn);
document.addEventListener("click", (e) => {
  if (e.target.classList.contains("modal-overlay") && e.target.closest("details").hasAttribute("open")) {
    e.target.closest("details").removeAttribute("open");
    document.querySelector(".section-header").classList.remove("menu-open");
  }
  if (e.target.classList.contains("extra_color_button")) {
    e.target.style.display = "none";
    e.target.closest(".card-variation-color").querySelectorAll(".color-hide-plus").forEach((ele) => {
      ele.classList.remove("color-hide-plus")
    })
  }
  if (e.target.classList.contains("mobile-popup-variant")) {
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
    let $elementVariant = document.querySelector(`#${e.target.value}`);
    var evt = document.createEvent("HTMLEvents");
    evt.initEvent("change", false, true);
    $elementVariant.click();
    $elementVariant.dispatchEvent(evt);
  }
  if (e.target.classList.contains("product-vars-inner-main-popup")) {
    e.target.classList.remove("active");
  }
  if (e.target.classList.contains("variant_popup_close_mobile") || e.target.closest(".variant_popup_close_mobile")) {
    e.target.closest(".product-vars-inner-main-popup").classList.remove("active");
  }
  // mobile quick view js starts from here
  if (e.target.classList.contains("mobile-quickview") || e.target.closest(".mobile-quickview")) {
    // const quickViewButtons = document.querySelectorAll(".mobile-quickview");
    // if (quickViewButtons.length > 0) {
    // quickViewButtons.forEach((button) => {
    // button.addEventListener("click", (evt) => {
    // });
    // });
    // }
    const cardWrapper = e.target.closest(".card-wrapper");
    if (!cardWrapper) return;
    const quickAddButton = cardWrapper.querySelector(".quick-add__submit");
    quickAddButton?.click();

    const variantRadios = cardWrapper.querySelector(".product-card_inline-variation input[name='מידה']");
    const mobilePopupElement = document.querySelector(".product-vars-inner-main-popup");
    console.log('variantRadios1', variantRadios)

    if (mobilePopupElement) {
      const variationContainer = mobilePopupElement.querySelector(".variantion-item-radios");
      if (variationContainer && variantRadios) {
        mobilePopupElement.classList.add("active");
        let sizeVariantsHTML = "";
        cardWrapper.querySelectorAll(".product-card_inline-variation input[name='מידה']").forEach((input) => {
          let $disableClass;
          if (input.classList.contains("disabled")) {
            $disableClass = "disabled";
          }
          sizeVariantsHTML += `<button type="button" value="${input.getAttribute("id")}" class="mobile-popup-variant" ${$disableClass}>${input.value}</button>`;
        });
        variationContainer.innerHTML = sizeVariantsHTML;
      }
    }
  }
  // ends here
})
document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelector(".header-icon-search-mobile").addEventListener("click", () => {
    if (document.querySelector(".header__search details").hasAttribute("open")) {
      document.querySelector(".section-header").classList.remove("menu-open");
    } else {
      document.querySelector(".section-header").classList.add("menu-open");
    }
    if (document.querySelector("#Details-menu-drawer-container").hasAttribute("open")) {
      document.querySelector("#Details-menu-drawer-container").removeAttribute("open");
      document.querySelector("#Details-menu-drawer-container").classList.remove("menu-opening");
      document.querySelector(".header__icon--menu").setAttribute("aria-expanded", false);
      document.body.classList.remove("overflow-hidden-tablet")
    }
  })
  if (document.body.classList.contains("product-template")) {
    function scrollToTop() {
      window.scrollTo(0, 0);
    }
    scrollToTop()
  }
});


document.addEventListener('DOMContentLoaded', function () {
  const targetContainer = document.querySelector('#size_chart_content');
  const checkedVariantInputs = document.querySelectorAll(".card-variation-color input:checked");

  /** -----------------------------
   * Load Size Chart
   * ----------------------------- */
  if (targetContainer) {
    fetch('https://x30.co.il/pages/size-chart')
      .then(response => response.text())
      .then(html => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        const sizeChartTables = tempDiv.querySelectorAll('.sizechart_tables');
        targetContainer.innerHTML = ''; // clear old content

        sizeChartTables.forEach(table => {
          targetContainer.appendChild(table.cloneNode(true));
        });

        initSizeChartScripts();
      })
      .catch(err => console.error('Error loading size chart:', err));
  }

  /** -----------------------------
   * Run ProductCardColor on page load
   * ----------------------------- */
  if (checkedVariantInputs.length) {
    setTimeout(() => {
      // checkedVariantInputs.forEach(input => ProductCardColor(input));
    }, 200); // small delay to let Flickity initialize
  }

  /** -----------------------------
   * Run ProductCardColor on change
   * ----------------------------- */
  document.addEventListener('change', function (ev) {
    if (ev.target.matches('.custom_variation_button')) {
      // ProductCardColor(ev.target);
    }
  });

  /** -----------------------------
   * Size Chart Tabs
   * ----------------------------- */
  function initSizeChartScripts() {
    const optionButtons = document.querySelectorAll('.option_btn');
    const tables = document.querySelectorAll('.size_chart_tables');

    optionButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tableId = button.getAttribute('data-table');

        tables.forEach(table => table.classList.remove('active'));
        optionButtons.forEach(btn => btn.classList.remove('active'));

        const selectedTable = document.querySelector(`.size_chart_tables[data-table="${tableId}"]`);
        if (selectedTable) selectedTable.classList.add('active');

        button.classList.add('active');
      });
    });
  }

  /** -----------------------------
   * Product Card Image Switcher
   * ----------------------------- */
  // Standalone function to get variant image by color
  function updateSingleMedia(card, color) {
    const variantData = JSON.parse(card.querySelector('[type="application/json"]').textContent); // assuming variant JSON is stored in DOM
    const single_variant_data = variantData.find(variant => variant.title.includes(color));
    return single_variant_data && single_variant_data.featured_image
      ? single_variant_data.featured_image.src
      : false;
  }

  // Handle product card variant image update
  function ProductCardColor(target) {
    let Target_varID = Number(target.getAttribute("data-variant-id"));
    target.closest(".card-wrapper").querySelector("variant-radios").querySelector("[name='id']").value = Target_varID;
    document.querySelectorAll(".product-card-wrapper").forEach(card => {
      const variantSelect = card.querySelector("variant-selects, .product-form__input");
      if (!variantSelect) return;

      // Get the initially selected color (from select or radio)
      let selectedColor = null;
      const checkedInput = variantSelect.querySelector("input[type=radio]:checked");
      const selectedOption = variantSelect.querySelector("select");

      if (checkedInput) {
        selectedColor = checkedInput.value;
      } else if (selectedOption) {
        selectedColor = selectedOption.value;
      }
      if (selectedColor) {
        const variant_image = updateSingleMedia(card, selectedColor);

        if (card.querySelector(".card__media").classList.contains("enable_image_slider")) {
          if (variant_image) {
            let target_index =
              card
                .querySelector(`.card__media img[src="${variant_image}"]`)
                ?.closest(".pro-media")
                ?.dataset.index || 0;

            const flkty = Flickity.data(card.querySelector(".card__media .flickity_grid"));
            if (flkty) {
              flkty.select(target_index);
            }
          }
        } else {
          if (variant_image) {
            const imgEl = card.querySelector("img.variant_image_element");
            if (imgEl) {
              imgEl.srcset = variant_image;
              imgEl.src = variant_image;
            }
          }
          card.classList.add("variant_image_active");
        }
      }
    });
  }

  // Run on page load
  // document.addEventListener("DOMContentLoaded", ProductCardColor);

  // Expose globally if you need to trigger manually
  // window.ProductCardColor = ProductCardColor;

});

